import * as yup from 'yup'

export class NeedsClusterReinstalledComboPhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
    clusterReinstallComboPhotoFile?: File = undefined
}

export const NeedsClusterReinstalledComboPhotoDtoSchema = yup.object({
    clusterReinstallComboPhotoFile: yup
    .mixed()
    // @ts-ignore
    .test('Combo Photo is Required..', 'File ', (value: File) => value)
    .required('Combo Photo is Required.')
})
